import { module } from "angular";
import { LoadingOverlayComponent } from "./LoadingOverlayComponent";

module("mmGui").component("irLoadingOverlay", new LoadingOverlayComponent());
